module.exports = __webpack_public_path__ + "img/oaFlowData194@3x.18f6bc1f.png";